import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-org": () => import("/vercel/path0/middleware/auth-org.js"),
  auth: () => import("/vercel/path0/middleware/auth.js"),
  "public-site": () => import("/vercel/path0/middleware/public-site.js")
}